import { ECardType, ICard } from './types';

export const DESKTOP_CARDS_ORDER: ECardType[] = [
  ECardType.VerticalHalfImage,
  ECardType.HorizontalHalfImage,
  ECardType.HorizontalFullImage,
  ECardType.VerticalFullImage,
  ECardType.VerticalHalfImage,
  ECardType.HorizontalHalfImage,
  ECardType.HorizontalFullImage,
  ECardType.VerticalFullImage,
  ECardType.HorizontalHalfImage,
  ECardType.HorizontalFullImage,
  ECardType.VerticalFullImage,
];

export const LAPTOP_CARDS_ORDER: ECardType[] = [
  ECardType.VerticalHalfImage,
  ECardType.VerticalHalfImage,
  ECardType.VerticalFullImage,
  ECardType.VerticalFullImage,
  ECardType.VerticalHalfImage,
  ECardType.VerticalHalfImage,
  ECardType.VerticalFullImage,
  ECardType.VerticalFullImage,
  ECardType.VerticalHalfImage,
  ECardType.VerticalFullImage,
  ECardType.VerticalFullImage,
];

export const GLAMOROUS_CARDS: ICard[] = [
  {
    title: 'Ипотечный калькулятор',
    description: 'Оцените свои финансовые возможности. Рассчитайте кредит на покупку квартиры',
    link: 'https://cian.ru/ipoteka/calculator?banner=header-calc',
    imageUrl: require('./assets/ipotechnyj_kalkulyator.jpg'),
    buttonText: 'Рассчитать ипотеку',
  },
  {
    title: 'Материнский капитал',
    description:
      'От государства можно получить 453 тыс. рублей на покупку квартиры. Но надо знать, как получить эти деньги',
    link: 'https://cian.ru/stati-pjat-pravil-dlja-sdelok-s-matkapitalom-282810',
    imageUrl: require('./assets/matkapital.jpg'),
    buttonText: 'Узнать больше',
  },
  {
    title: 'Покупаем квартиру: восемь шагов к новоселью',
    description:
      'Как выбрать правильную» квартиру, за что придется платить, на чем можно сэкономить, что проверить, чтобы вас не обманули, – рассказываем «на пальцах»',
    link: 'https://www.cian.ru/stati-pokupaem-kvartiru-vosem-shagov-k-novoselju-289247',
    imageUrl: require('./assets/pokupaem_kvartiru.jpg'),
  },
  {
    title: 'Мифы о льготной ипотеке для семей с детьми',
    description: 'Как не получить отказ в льготном кредитовании? Развенчиваем мифы и даем советы',
    link: 'https://cian.ru/stati-mify-o-lgotnoj-ipoteke-dlja-semej-s-detmi-281609',
    imageUrl: require('./assets/mify_lgotnaya_ipoteka.jpg'),
  },
  {
    title: 'Квартира или апартаменты?',
    description: 'Что важнее: цена или «прописка»? Цена или налоги? Цена или стоимость эксплуатации? Давайте посчитаем',
    link: 'https://www.cian.ru/stati-kvartira-vs-apartamenty-283190',
    imageUrl: require('./assets/kvartira_ili_apartamenty.jpg'),
  },
  {
    title: 'Идеальная ипотека: советы заемщикам',
    description:
      'Как не ошибиться при покупке ипотечной квартиры, грамотно выбрать банк и ловко избежать типичных банковских «ловушек»',
    link: 'https://cian.ru/stati-idealnaja-ipoteka-sovety-zaemschikam-283790',
    imageUrl: require('./assets/idealnaya_ipoteka.jpg'),
  },
  {
    title: 'Как не лишиться купленной квартиры',
    description:
      'Купить квартиру – еще не все. Важно ее потом не потерять в результате мошеннических действий. Объясняем, как защитить себя от мошенников',
    link: 'https://www.cian.ru/stati-kak-zaschitit-sebja-ot-moshennikov-pri-pokupke-kvartiry-282347',
    imageUrl: require('./assets/kak_ne_lishitsya_kvartiry.jpg'),
  },
  {
    title: 'Как найти хорошего риэлтора?',
    description: 'Кого выбрать: частного риэлтора или агентство недвижимости? Что должен уметь настоящий профессионал?',
    link: 'https://www.cian.ru/stati-kak-najti-rieltora-276539',
    imageUrl: require('./assets/kak_najti_riehltora.jpg'),
  },
  {
    title: 'Кому банки дают ипотеку на квартиру, а кому отказывают?',
    description: 'Поводом для отказа может быть даже причина, которая вам покажется несущественной',
    link: 'https://www.cian.ru/stati-komu-banki-dajut-ipoteku-na-kvartiru-a-komu-otkazyvajut-287274',
    imageUrl: require('./assets/komu_banki_dayut_ipoteku.jpg'),
  },
  {
    title: 'Семь критериев оценки эффективной работы риэлтора',
    description:
      'Многие ожидают, что риэлтор снимет всю «головную боль» по сделке. Однако на практике это не всегда так',
    link: 'https://www.cian.ru/stati-sem-kriteriev-otsenki-effektivnoj-raboty-rieltora-286322',
    imageUrl: require('./assets/sem_kriteriev_otsenki.jpg'),
  },
  {
    title: 'Ипотечная квартира: как получить налоговый вычет',
    description:
      'После покупки квартиры можно вернуть до 650 тыс. рублей в семейный бюджет. Рассказываем, как это сделать',
    link: 'https://www.cian.ru/stati-ipotechnaja-kvartira-kak-poluchit-nalogovyj-vychet-277862',
    imageUrl: require('./assets/ipotechnaya_kvartira.jpg'),
  },
];
